import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './MockApiGenerator.css'
import { FIELD_TYPES, generateMockRecords } from './utils/mockApiGenerator'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const DEFAULT_FIELDS = [
  { name: 'id', type: 'uuid' },
  { name: 'nome', type: 'name' },
  { name: 'email', type: 'email' },
]

const MockApiGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de Mock de API/JSON | jarder.dev',
    description:
      'Monte os campos e gere um array de dados fake no formato de ' +
      'resposta de API, pronto pra usar em testes de front-end. Grátis.',
  })

  const [fields, setFields] = useState(DEFAULT_FIELDS)
  const [count, setCount] = useState('5')
  const [output, setOutput] = useState('')

  const updateField = (index, key, value) => {
    setFields((current) =>
      current.map((f, i) => (i === index ? { ...f, [key]: value } : f)),
    )
  }

  const addField = () => {
    setFields((current) => [...current, { name: '', type: 'word' }])
  }

  const removeField = (index) => {
    setFields((current) => current.filter((_, i) => i !== index))
  }

  const generate = () => {
    const n = Math.max(1, Math.min(Number.parseInt(count, 10) || 1, 100))
    const records = generateMockRecords(fields, n)
    setOutput(JSON.stringify(records, null, 2))
    trackEvent('tool_generate', { tool: 'mock_api', count: n, fields: fields.length })
  }

  const copy = () => {
    navigator.clipboard.writeText(output)
    trackEvent('tool_copy', { tool: 'mock_api' })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Gerador de Mock de API</h1>
      <p className="tool-disclaimer">
        Monte os campos, escolha o tipo de cada um e gere um array de
        dados fake no formato de resposta de API.
      </p>

      <div className="mock-api-fields">
        {fields.map((field, i) => (
          <div className="tool-row mock-api-field-row" key={i}>
            <div className="tool-field">
              <label htmlFor={`field-name-${i}`}>Nome do campo</label>
              <input
                id={`field-name-${i}`}
                type="text"
                value={field.name}
                onChange={(e) => updateField(i, 'name', e.target.value)}
              />
            </div>
            <div className="tool-field">
              <label htmlFor={`field-type-${i}`}>Tipo</label>
              <select
                id={`field-type-${i}`}
                value={field.type}
                onChange={(e) => updateField(i, 'type', e.target.value)}
              >
                {FIELD_TYPES.map((t) => (
                  <option key={t.key} value={t.key}>
                    {t.label}
                  </option>
                ))}
              </select>
            </div>
            <button
              type="button"
              className="tool-button tool-button-secondary mock-api-remove"
              onClick={() => removeField(i)}
            >
              Remover
            </button>
          </div>
        ))}
      </div>

      <button
        type="button"
        className="tool-button tool-button-secondary"
        onClick={addField}
        style={{ marginBottom: 20 }}
      >
        + Adicionar campo
      </button>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="count">Quantos registros</label>
          <input
            id="count"
            type="number"
            min="1"
            max="100"
            value={count}
            onChange={(e) => setCount(e.target.value)}
          />
        </div>
      </div>

      <button type="button" className="tool-button" onClick={generate}>
        Gerar JSON
      </button>

      {output && (
        <div className="tool-field" style={{ marginTop: 20 }}>
          <textarea rows="16" readOnly value={output} />
          <button
            type="button"
            className="tool-button tool-button-secondary"
            onClick={copy}
          >
            Copiar
          </button>
        </div>
      )}

      <div className="tool-info-section">
        <h2>Para que serve</h2>
        <p>
          Útil para desenvolver uma tela de front-end antes da API real
          estar pronta, escrever testes automatizados com dados
          previsíveis ou simular respostas de endpoints durante
          demonstrações. Defina os campos e o tipo de cada um (nome,
          e-mail, UUID, data, número...) e gere quantos registros
          precisar, no formato de array JSON que uma API tipicamente
          retornaria.
        </p>
      </div>
    </div>
  )
}

export default MockApiGenerator
